module.exports = __webpack_public_path__ + "static/media/mascot-jump1.7d81cdd9.png";